<template>
  <v-layout
    row
    wrap
  >
    <v-flex xs12>
      <div
        v-for="option in options"
        :key="option.value"
      >
        <v-checkbox
          v-model="selectedArray"
          :label="option.value"
          :value="option.value"
          style="height:30px"
          color="primary"
        />
      </div>
    </v-flex>
  </v-layout>
</template>
<script>
export default {
  name: 'CheckboxGroup',
  model: {
    prop: 'inputValue',
    event: 'change'
  },
  props: {
    inputValue: {
      type: String,
      default: '',
      required: true
    },
    options: {
      type: Array,
      default: () => [],
      required: true
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selectedArray: []
    };
  },
  computed: {
    selected: {
      get() {
        return this.inputValue;
      },
      set(newVal) {
        const selectedArray = newVal.split(',');
        this.selectedArray = selectedArray;
      }
    }
  },
  watch: {
    inputValue: {
      handler(val) {
        if (!val) return;
        this.selected = val;
      },
      immediate: true
    },
    selectedArray: {
      handler(val) {
        if (!val) return;
        this.$emit('change', val.toString());
      },
      immediate: true
    }
  }
};
</script>
<style scoped>
.v-input--selection-controls {
  margin-top: 0;
}
</style>

